import dayjs from "dayjs";
import { convertFirebaseDates, getDayOfWeek } from "helpers/dates";

export const findHabitForDate = (habits, date) => {
  // date is expected as a string 'YYYY-MM-DD' or a Date object
  const target = dayjs(date);
  // Find the habit with the latest start date before or equal to the target date
  return habits
    .filter(h => dayjs(h.start).isSameOrBefore(target, 'day'))
    .sort((a, b) => dayjs(b.start).valueOf() - dayjs(a.start).valueOf())[0] || null;
}

export const findSubscriptionForDate = (userHabits, date, restrictedMeal=null) => {
  if (!userHabits || !date) return null;

  const foundHabit = findHabitForDate(convertFirebaseDates(userHabits), date);

  if(!foundHabit) return null;

  if(restrictedMeal && (!foundHabit?.[restrictedMeal] || !foundHabit[restrictedMeal].includes(getDayOfWeek(date)))) return null;

  return foundHabit;
};